module.exports = __webpack_public_path__ + "img/pluviometro.52915221.svg";